import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo("en-US");

class ListView {
  _parentElement = document.querySelector(`.list_container`);
  _data;
  _dateFormatting = {
    day: `numeric`,
    month: `short`,
  };

  render(data) {
    this._data = data;

    const markup = this._data.reduce((acc, commit) => {
      return (acc += this._generateMarkup(commit));
    }, ``);

    this._clear();
    this._parentElement.insertAdjacentHTML(`afterbegin`, markup);
  }

  _generateMarkup(commit) {
    return `
        <li>
          <p class="day">${this._day(commit.date)}</p>
          <a href="${commit.url}">
            <div class="day_container">
              <h2>${commit.title}</h2>
              <p>${timeAgo.format(commit.date)}</p>
            </div>
          </a>
        </li>
        `;
  }

  _clear() {
    this._parentElement.innerHTML = ``;
  }

  _day(commitDate) {
    const today = new Date();

    if (
      commitDate.getDate() == today.getDate() &&
      commitDate.getMonth() == today.getMonth() &&
      commitDate.getFullYear() == today.getFullYear()
    )
      return `Today`;

    return new Intl.DateTimeFormat("en-US", this._dateFormatting).format(
      commitDate
    );
  }
}

export default new ListView();
